import { searchProcedureMiddleware } from './searchProcedure';
import { projectMiddleware } from './project';

export default [searchProcedureMiddleware, projectMiddleware];
